<div *ngIf="objetivesForEdit">
    <div *ngFor="let objetive of objetivesForEdit; let i = index">
        <app-inputs 
            [disable]="disable" 
            [objetive]="objetive" 
            [i]="i" 
            (removeObjetiveEvent)="removeObjetiveFromEdit(i)" 
            (saveObjetiveEvent)="saveObjetiveFromInputComponent($event)">
        </app-inputs>
    </div>
</div>

<div *ngFor="let objetive of objetives; let i = index">
    <app-inputs
        [disable]="disable" 
        [i]="i" 
        (removeObjetiveEvent)="removeObjetive(i)" 
        (saveObjetiveEvent)="saveObjetiveFromInputComponent($event)">
    </app-inputs>
</div>
 
<button (keydown.enter)="$event.preventDefault()" *ngIf="!disable" [disabled]="disable" (click)="addObjetive()" mat-button color="primary" id="addButton">
    {{ 'registration.stepThree.objetives.add' | translate}}
</button>